export class FileItem {
  public archivo: File;
  public nombreArchivo: string;
  public url: string;
  public estaSubiendo: boolean;
  public progreso: number;
  public fechaSubida?: number;
  public keyLevantamientoObra?: string;

  constructor(archivo: File) {
    this.archivo = archivo;
    this.nombreArchivo = `${this.formatDate(new Date().getTime())} - ${
      archivo.name
    }`;
    this.estaSubiendo = false;
    this.progreso = 0;
    this.fechaSubida = new Date().getTime();
  }

  formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    switch (month) {
      case "1":
        month = "Enero";
        break;
      case "2":
        month = "Febrero";
        break;
      case "3":
        month = "Marzo";
        break;
      case "4":
        month = "Abril";
        break;
      case "5":
        month = "Mayo";
        break;
      case "6":
        month = "Junio";
        break;
      case "7":
        month = "Julio";
        break;
      case "8":
        month = "Agosto";
        break;
      case "9":
        month = "Septiembre";
        break;
      case "10":
        month = "Octubre";
        break;
      case "11":
        month = "Noviembre";
        break;
      case "12":
        month = "Diciembre";
        break;
    }

    return [year, month, day].join("-");
  }
}
